import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';

const BlogHeader = () => {
    const { t } = useTranslations();

    return (
        <section className="blog-overview-header">
            <div className="blog-header-glow"></div>

            <div className="container" style={{ position: 'relative', zIndex: '2' }}>
                <div className="row">
                    <div className="col-12 text-center">
                        <FadeInAnimation direction="up" delay={50}>
                            <span className="blog-header-badge">
                                {t('blog_header_badge')}
                            </span>

                            <h1 className="blog-header-title">
                                {t('blog_header_title')}
                            </h1>

                            <p className="blog-header-description">
                                {t('blog_header_description')}
                            </p>
                        </FadeInAnimation>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BlogHeader;
